import { Component, Input } from "@angular/core";
import { DataTableDirective } from "../data-table.directive";

@Component({
	selector: "app-paginator-pages",
	standalone: false,
	templateUrl: "./paginator-pages.component.html",
	styleUrl: "./paginator-pages.component.scss"
})
export class PaginatorPagesComponent {
	@Input() mfTable: DataTableDirective;
}